import {gql} from 'apollo-boost'

export const SIGN_IN = gql`
  mutation signIn($username: String!, $password: String!, $type: String!) {
    signIn(
      username: $username,
      password: $password,
      type: $type,
    ) {
      token
      user {
        id
        photo
        prefix{
          id
          nameTh
        }
        name
        surname
        username
        email
        status
        oneTimePassword
        oneTimePasswordReset
        updateInformation
        type
        profile{
          mobile
          email
        }
      }
    }
  }
`

export const SIGN_IN_DUMMY = gql`
  mutation signInDummy($id: ID!, $username: String!, $secretPublicKey: String!) {
    signInDummy(
      id: $id,
      username: $username,
      secretPublicKey: $secretPublicKey,
    ) {
      token
      user {
        id
        dummyInfo {
          id
          email
        }
        photo
        prefix{
          id
          nameTh
        }
        name
        surname
        username
        email
        status
        oneTimePassword
        oneTimePasswordReset
        updateInformation
        type
        profile{
          mobile
          email
        }
      }
    }
  }
`

export const RESET_KEY = gql`
  mutation resetKey($resetKey: String!) {
    resetKey(
      resetKey: $resetKey
    ) {
      token
      user {
        id
        photo
        prefix{
          id
          nameTh
        }
        name
        surname
        username
        email
        status
        oneTimePassword
        oneTimePasswordReset
        updateInformation
        type
        profile{
          mobile
          email
        }
      }
    }
  }
`

export const SIGN_OUT = gql`
  mutation signOut {
    signOut
  }
`

export const OTP_RESET = gql`
  mutation otpReset($newPassword: String!) {
    otpReset(
      newPassword: $newPassword
    ) {
      id
      photo
      prefix{
        id
        nameTh
      }
      name
      surname
      email
      status
      oneTimePassword
      oneTimePasswordReset
      updateInformation
      type
      profile{
        mobile
        email
      }
    }
  }
`

export const GET_CURRENT_USER = gql`
  query getCurrentUser {
    getCurrentUser{
      id
      photo
      prefix{
        id
        nameTh
      }
      name
      surname
      email
      status
      oneTimePassword
      oneTimePasswordReset
      updateInformation
      type
      profile{
        mobile
        email
      }
    }
  }
`

export const GET_NAVE_MENU_ITEM = gql`
  query getNaveMenuItem {
    getNaveMenuItem
  }
`

export const GET_PERMISSIONS = gql`
  query getPermissions {
    getPermissions
  }
`

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($idCardNumber: String!) {
    forgotPassword(
      idCardNumber: $idCardNumber
    ) {
      result
	    msg
    }
  }
`

export const UPDATE_INFORMATION = gql`
  mutation updateInformation($email: String!, $mobile: String!) {
    updateInformation(
      email: $email,
      mobile: $mobile,
    ) {
      result
	    msg
    }
  }
`

